import React from 'react';

const ContactPage = () => {
  return (
      <iframe class="airtable-embed airtable-dynamic-height" src="https://airtable.com/embed/shrJajJwO5QyqvApS?backgroundColor=cyan" frameborder="0"  width="100%" height="1018" style={{background: 'transparent'}}></iframe>
  )
}
export default ContactPage;